<div class="person-owner-container">
  <c11n-dropdown
    appDropdownTypeahead
    id="person-owner-dropdown"
    [labelText]="accountDetailsContent.ACCOUNT_DETAILS_INDIVIDUAL_NAME"
    [menuData]="ownerOptions"
    [activeItems]="selectedOwnerId ? [selectedOwnerId] : []"
    [placeholderText]="'Select an owner'"
    (stateChange)="onOwnerSelectionChange($event)">
  </c11n-dropdown>
</div>
